import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import Card from "../../Components/Card_wrap";
import Chart from "react-apexcharts";
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import BasicButton from "../../Components/Button_Basic";

function DB10030(props) {
  HighchartsMore(Highcharts);

  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  // const formatTooltip = (tooltip, x, y, series) => {
  //   console.log("x: ", x, "y: ", y, "\nseries: ", series);
  //   let name = [];
  //   let data = [];
  //   y.map((item, index) => {
  //     name.push(item.name);
  //     data.push(item.data);
  //   });
  //   console.log(name);
  //   return y.map((item, index) => {
  //     `<b>${item.name}: </b>${item.data}`;
  //   });
  // };
  const item = ({ name, value }) => (
    <div>
      {name}: {value}
    </div>
  );
  const options = {
    chart: {
      type: "columnrange",
      inverted: true,
      innerHeight: "700px",
      height: 720,
    },
    title: {
      text: props.title,
    },
    colors: [
      "#bbfacf",
      "#64E572",
      "#c4d5f5",
      "#0257f5",
      "#f2dcce",
      "#fa6302",
      "#d3b8f5",
      "#7100ff",
    ],
    series: props.wkDate,

    xAxis: { categories: props.categoriesData },
    yAxis: {
      labels: {
        format: "{value:%y.%m.%d %H:%M }",
      },
      title: {
        text: "Date",
      },
    },
    plotOptions: {
      columnrange: {
        grouping: true,
        // borderRadius: "50%",
        dataLabels: {
          enabled: true,
          format: "{y:%y.%m.%d }",
        },
      },
    },
    tooltip: {
      formatter: function () {
        return (
          "품목명: " +
          this.series.name +
          "</br> 기간: " +
          Commons.DateFormating(new Date(this.point.low).toString(), 1) +
          " ~ " +
          Commons.DateFormating(new Date(this.point.high).toString(), 1) +
          "</br>"
          // +
          // "재고수량: " +
          // this.series.userOptions.qtyList +
          // "</br>" +
          // "필요수량: " +
          // this.series.userOptions.needQtyList
        );
      },
      // valueSuffix: "일",
      // formatter: () => {
      //   let s = `<b> ${"1"} </b>`;
      //   props.wkDate.map((item, index) => {
      //     s += `<b>${item.name}: </b>${new Date(item.data)}`;
      //   });
      //   console.log(s);
      //   return s;
      // },
    },
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignItems: "center",
      }}
    >
      {" "}
      <div style={{ width: "100%" }}>
        <Card
          wrapStyle={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <div>
            <BasicButton
              name="뒤로"
              onClick={(e) => {
                // console.log("props.soDate: ", props.soDate);
                // console.log("props.check: ", props.check);
                // console.log("props.processData: ", props.processData);
                // console.log("props.wkDate", props.wkDate);
                props.setProcess1("");
                props.setProcess2("");
                props.setProcess3("");
                props.setProcess4("");
                props.setProcess5("");
                props.setTotlaProcess("");
                props.setCategoriesData([]);
                props.setWkDate([]);
                props.setProcessCdCheck(false);
              }}
            />
          </div>
        </Card>
        <div>
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
      </div>
    </div>
  );
}

export default DB10030;
